import { render, staticRenderFns } from "./KeyboardNumerico.vue?vue&type=template&id=027a93d9"
import script from "./KeyboardNumerico.vue?vue&type=script&lang=js"
export * from "./KeyboardNumerico.vue?vue&type=script&lang=js"
import style0 from "./KeyboardNumerico.vue?vue&type=style&index=0&id=027a93d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports